import React from "react";
import "./styles/LoadingSpinner.scss";

const LoadingSpinner = () => (
  <div className="loading-container">
    <div className="loading-ring">
      <div></div>
    </div>
  </div>
);

export default LoadingSpinner;
